import { useEffect, useState } from "react";
import { _FixedAssetImages, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_md, MODAL_SM } from "../../../../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { Modal } from "../../../../../../theme/Component/Modal";
import { FileInput } from "../../../../../../theme/Component/FileInput";
import { FileService } from "../../../../../../../core/services/FileService";

interface propsComponent {
    IdFixedAssetItem: number;
}

export const FixedAssetImages = ({ IdFixedAssetItem }: propsComponent) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_FixedAssetImages);
    const fileService = new FileService();

    const [selectedIndex, setSelectedIndex] = useState<number>(0);

    const modal = useModal("Agregar Imgagen", MODAL_md);
    const modalC = useModal("Eliminar Imgagen", MODAL_SM);

    useEffect(() => {
        if (IdFixedAssetItem) {
            getLista();
        }
    }, [IdFixedAssetItem])

    const getLista = () => {
        const props: any = {
            IDItem: IdFixedAssetItem,
            State: 1
        };

        instance.getFixedAssetImagesCatalogPorPropiedades(props, null)
            .then(resp => {
                const listaImages = resp.map(element => {
                    const dataMedia = element.DataBeanProperties.Media;
                    const dataContext = element.DataBeanProperties.MediaContext;

                    return {
                        ...element,
                        DataBeanProperties: {
                            ...element.DataBeanProperties,
                            URLDOC: dataMedia && dataContext
                                ? fileService.getUrlFile(dataContext, dataMedia)
                                : "N/A"
                        }
                    };
                });

                if (listaImages.length > 0) {
                    setSelectedIndex(0);
                }

                setLista(listaImages);
            })
            .catch(err => {
                toast.error(err);
            });
    };

    const addImage = (obj: any) => {
        instance.updateFixedAssetImages(obj).then(
            (resp) => {
                modal.close();
                modalC.close();
                setBean({});
                getLista();
            }
        ).catch(
            err => {
                toast.error("No se pudo agregar la imagen");
                console.log(err)
            }
        )
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        addImage(x);
    };

    const create = () => {
        setBean({
            State: 1,
            IDItem: IdFixedAssetItem,
            IDEmployee: _single.getAccountID(),
        });
        modal.open("Crear grupo de Activo");
    }

    return (
        <>
            {lista?.length > 0 && (
                <div className="text-center mb-3">
                    <h3>{lista[selectedIndex].DataBeanProperties.MediaName ?? "N/A"}</h3>
                    <div
                        style={{
                            width: "100%",
                            maxWidth: "600px",
                            aspectRatio: "16 / 9",
                            margin: "0 auto",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            background: "#f8f9fa",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <img
                            src={lista[selectedIndex].DataBeanProperties.URLDOC}
                            alt="Imagen seleccionada"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                borderRadius: "6px"
                            }}
                        />
                    </div>


                </div>
            )}
            <div
                style={{
                    display: "flex",
                    gap: "10px",
                    padding: "10px 0",
                    overflowX: "auto"
                }}
            >
                <div
                    onClick={create}
                    style={{
                        width: "80px",
                        height: "60px",
                        border: "2px dashed #aaa",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        color: "#666",
                        fontSize: "24px",
                        flexShrink: 0
                    }}
                    title="Agregar imagen"
                >
                    +
                </div>

                {lista?.map((item, index) => {
                    const data = item.DataBeanProperties;

                    return (
                        <div
                            key={item.ID}
                            style={{
                                position: "relative",
                                cursor: "pointer",
                                border: selectedIndex === index
                                    ? "2px solid #007bff"
                                    : "1px solid #ccc",
                                borderRadius: "6px",
                                padding: "3px",
                                flexShrink: 0
                            }}
                            onClick={() => setSelectedIndex(index)}
                        >
                            <span
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setBean(data);
                                    modalC.open("Eliminar imagen");
                                }}
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "-6px",
                                    background: "#dc3545",
                                    color: "#fff",
                                    borderRadius: "50%",
                                    width: "18px",
                                    height: "18px",
                                    fontSize: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    zIndex: 2
                                }}
                            >
                                ✕
                            </span>

                            <img
                                src={data.URLDOC}
                                style={{
                                    width: "80px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "4px"
                                }}
                            />
                        </div>
                    );
                })}
            </div>



            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { addImage(bean) }}>
                <div className="row">
                    <div className="col-md-12">
                        <FileInput onCreate={(e) => { setBean({ ...bean, Media: e.Media, MediaContext: e.MediaContext, MediaName: e.Name }) }} docAcept="image/jpeg, image/png, image/gif, image/bmp, image/tiff, image/svg+xml" />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalC.modal} updateModal={modalC.setModal} eventModal={() => { deleteItem() }}>
                <p>Desea eliminar {bean.MediaName}</p>
            </Modal>

        </>
    )
}